<template>
    <div class="col-12">
        <div class="row mt-4">
            <b-col cols="1" class="p-0 text-center">
                <div
                    class="position-relative h-100"
                    id="icone-status-atual"
                >
                    <i class="fas fa-circle fa-lg text-warning"></i>
                </div>
            </b-col>
            <b-col cols="11">
                <StatusAtual
                    :idServicoAtendimento="idServicoAtendimento"
                    :servico="servico"
                    :horario="horaStatus"
                    :status="status"
                />
                <div class="clearfix mt-2">
                    <BotaoVerMais
                        :id="idBotaoVerMais"
                        :classes="'btn-sm float-right'"
                        :target="'historico'"
                        :textoAbrir="'Ver mais'"
                        :textoFechar="'Ver menos'"
                        @acaoVerMais="abrirMaisDados()"
                    />
                </div>
            </b-col>
        </div>

        <div class="row">
            <b-col cols="12" class="mt-1">                
                <b-collapse id="historico">
                    <div class="row mapa" v-if="exibirMapa" :style="{'height': alturaMapa}">
                        <MapaEnderecoAtendimento 
                            :coordenadas="coordenadas"
                            :idServicoAtendimento="idServicoAtendimento" />
                    </div>
                    <b-card class="border-light borda-redonda sombra" :style="estiloCardMaisDados">
                        <MaisDados
                            :enderecoOrigem="enderecoOrigem"
                            :enderecoDestino="enderecoDestino"
                            :status="status"
                            :servico="servico"
                            :exibirRastreioPrestadores="exibirRastreioPrestadores"

                        />
                    </b-card>
                </b-collapse>
            </b-col >
        </div>

        <div class="row">
            <b-col class="col-12 mt-4" v-show="servico.chegadaConfirmadaPor != 'SOLICITANTE' && exibirCaixaMarcarChegada">
                <MarcarChegada 
                    :idServicoAtendimento="idServicoAtendimento"
                    :servico="servico"
                 />
            </b-col>
            <b-col class="col-12 mt-4">
                <EnviarAnexo />
            </b-col>
        </div>

    </div>
</template>

<script>
import StatusAtual from "@/components/StatusAtual.vue";
import BotaoVerMais from "@/components/Botoes/BotaoVerMais.vue";
import MaisDados from "@/components/MaisDados.vue";
import EnviarAnexo from "@/components/EnviarAnexo.vue";
import MarcarChegada from "@/components/MarcarChegada.vue";
import MapaEnderecoAtendimento from '@/components/Mapa/MapaEnderecoAtendimento.vue';
import { mapState, mapActions } from "vuex";
import * as CoordenadasAtendimentoService from '@/services/CoordenadasAtendimento';
import barramentoEndereco from '@/bus/endereco';

export default {
    data() {
        return {
            estiloCardMaisDados: {},
            intervaloRastrear: null,
            intervaloPodeMarcarChegada: null,
            podeMarcarChegada: false,
            idBotaoVerMais: 'verMaisDados_' + this.$func.uniqueID(),
        }
    },
    props: {
        exibirRastreioPrestadores: String,
        status: String,
        horaStatus: String,
        enderecoOrigem: Object,
        enderecoDestino: Object,
        anexos: [Object, Array],
        servico: {
            type: Object,
            default: function () {
                return {};
            },
        },
        idServicoAtendimento: String
    },
    components: {
        StatusAtual,
        BotaoVerMais,
        MaisDados,
        EnviarAnexo,
        MarcarChegada,
        MapaEnderecoAtendimento
    },
    computed: {
        ...mapState('Atendimento', {
            temServicos: 'temServicos',
            coordenadasAtendimento: 'coordenadasAtendimento',
            idAtendimentoUrl: 'idAtendimentoUrl',
        }),
        exibirMapa() {
            const exibir = this.temServicos && [
                'PRESTADOR_ACIONADO',
                'PRESTADOR_A_CAMINHO',
                'PRESTADOR_CHEGOU_LOCAL',
                'VIAJANDO_PARA_DESTINO',
                'FINALIZADO'
            ].indexOf(this.servico.status) > -1;

            this.alterarPosicaoCardMaisDados(exibir);
            
            return exibir;
        },
        coordenadas() {
            let coordenadas = [...this.coordenadasAtendimento];
            if (this.exibirRastreioPrestadores == 'S') {
                coordenadas.push(...CoordenadasAtendimentoService.montarCoordernasPrestador(this.servico));
            }
            return coordenadas;
        },
        exibirCaixaMarcarChegada() {
            return this.podeMarcarChegada;
        },
        alturaMapa() {
            return this.exibirRastreioPrestadores == 'S' ? '70vh' : '40vh';
        }
    },
    watch: {
        atendimento: function() {
            this.atualizarRastreio();
        },
        servico: function() {
            this.clicarVerMais();
            this.atualizarPodeMarcarChegada();
        }
    },
    methods: {
        ...mapActions("Atendimento", ["buscarDadosAtendimento"]),
        alterarPosicaoCardMaisDados(exibindoMapa) {
            this.estiloCardMaisDados = {};
            if (exibindoMapa) {
                this.estiloCardMaisDados = {
                    'margin-top': '-90px',
                    'z-index': '1000',
                    'position': 'relative'
                }
            }
        },
        atualizarRastreio() {
            if (this.exibirRastreioPrestadores != "S") {
                clearInterval(this.intervaloRastrear);
            } else if (this.exibirRastreioPrestadores == "S" && this.intervaloRastrear == null) {
                this.intervaloRastrear = setInterval(() => {
                    this.atualizarDados();
                }, 60000);
            }
        },
        atualizarDados() {
            this.buscarDadosAtendimento({
                idAtendimento: this.idAtendimentoUrl,
                atualizar: true,
            });            
        },
        abrirMaisDados() {
            barramentoEndereco.$emit('centralizarMapa');
        },
        clicarVerMais() {
            const divMaisDados = document.getElementById(this.idBotaoVerMais);
            if (this.temServicos) {
                if (!document.getElementById("historico").classList.contains("show")) {
                    divMaisDados.click();
                }
            } else {
                if (document.getElementById("historico").classList.contains("show")) {
                    divMaisDados.click();
                }
            }
        },
        verificaPodeMarcarChegada() {
            if (this.temServicos && this.status == 'PRESTADOR_A_CAMINHO' && 
                !this.$func.isEmpty(this.servico.previaServico) && !this.$func.isEmpty(this.servico.dataCadastroServico)) {
                const previsaoMinutos = this.$func.tempoEmMinutos(this.servico.previaServico);
                const dataCadastroServico = this.$moment(this.servico.dataCadastroServico, "DD/MM/YYYY HH:mm:ss");
                const agora = this.$moment();
    
                // Calcula a diferença em minutos entre a data em que o serviço foi cadastrado e a data de agora
                const duration = this.$moment.duration(agora.diff(dataCadastroServico));
                const difMinutes = duration.asMinutes();
    
                // se a diferença for menor que 20% não deixa marcar a chegada
                const porcentagem = ((difMinutes * 100) / previsaoMinutos).toFixed(2);
                if (porcentagem >= 20) {
                    clearInterval(this.intervaloPodeMarcarChegada);
                    this.podeMarcarChegada = true;
                }
            } else if (!this.$func.isEmpty(this.servico.dataHorarioChegada)) {
                this.podeMarcarChegada = false;
            }
        },
        atualizarPodeMarcarChegada() {
            if (!this.temServicos) {
                clearInterval(this.intervaloPodeMarcarChegada);
                this.podeMarcarChegada = false;
            } else {
                this.intervaloPodeMarcarChegada = setInterval(() => {
                    this.verificaPodeMarcarChegada();
                }, 5000);
            }
        },
    },
    created() {
        this.atualizarRastreio();
    },
    mounted() {
        this.clicarVerMais();
        this.verificaPodeMarcarChegada();
        this.atualizarPodeMarcarChegada();
    }
}
</script>

<style scoped>
#desabilitar-mapa {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 410;
    background-color: #efebeb;
    opacity: 0.5;
}
</style>